import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import { useEffect, useState } from 'react'
import { trpc } from '../../utils'
import { startTmaParamsSchema } from '../../utils/generateStartTmaUrl'
import { useModal, useNavigation } from '..'

export const useStartParam = (props: {
  joinTable: (table: { id: string; password: string | null }) => void
}) => {
  const { startParam: launchParam } = retrieveLaunchParams()
  const { openInfoModal } = useModal()
  const { goToPage } = useNavigation()
  const getTable = trpc.table.getTable.useMutation()
  const [inviterUserId, setInviterUserId] = useState<string>()
  const [sourceOrigin, setSourceOriginal] = useState<string>()
  const [isLoaded, setIsLoaded] = useState(false)

  const resetSearchParams = () => {
    const url = new URL(window.location.href)

    url.searchParams.delete('start_param')
    url.searchParams.delete('startapp')

    history.replaceState(null, '', url.toString())
  }

  const handleTableLink = async (table: {
    code: string
    password: string | null
  }) => {
    try {
      const tableInfo = await getTable.mutateAsync(table)
      props.joinTable({
        id: tableInfo.id,
        password: tableInfo.password,
      })
    } catch (error) {
      if (error instanceof Error) {
        openInfoModal(
          {
            text: error.message,
          },
          {
            title: 'Error',
            name: 'info_start_table_error',
          },
        )
        return
      }
      console.error('Invite table error', error)
    }
  }

  const handleStartParam = async () => {
    const searchParams = new URLSearchParams(window.location.search)
    const utmSource = searchParams.get('utm_source')
    const startParam =
      launchParam ||
      searchParams.get('start_param') ||
      searchParams.get('startapp')
    try {
      if (utmSource) {
        setSourceOriginal(utmSource)
      }
      if (startParam) {
        const dataString = atob(startParam)
        const startParamJson = startTmaParamsSchema.safeParse(
          JSON.parse(dataString),
        )
        if (startParamJson.error) {
          return
        }
        // TODO: remove inviterId across the client (we handle that in a bot now)
        if (startParamJson.data.inviterId) {
          setInviterUserId(startParamJson.data.inviterId)
        }
        if (startParamJson.data.navigation) {
          if (startParamJson.data.navigation.page === 'table') {
            await handleTableLink({
              code: startParamJson.data.navigation.params.code,
              password: startParamJson.data.navigation.params.password || null,
            })
            return
          }
          goToPage(startParamJson.data.navigation.page)
        }
        return
      }
    } finally {
      resetSearchParams()
      setIsLoaded(true)
    }
  }

  useEffect(() => {
    void handleStartParam()
  }, [])

  return {
    isLoaded,
    inviterUserId,
    sourceOrigin,
  }
}
